import { useDispatch, useSelector } from "react-redux";
import { printTradesThunk } from "../thunks/printTradesThunk";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { Trades } from "../types";

export const useTradesPrinter = (trade?: Trades) => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.domestic.trades.printTradeFetchState
	);
	const dispatch = useDispatch();
	const download = React.useCallback(() => {
			dispatch(printTradesThunk(trade));
	}, [dispatch, trade]);

	return [download, fetchState] as [typeof download, typeof fetchState];
};
